import { extendTheme } from '@chakra-ui/react';
import { Breadcrumb } from '../shared/breadcrumb';
import AccordionTheme from '../shared/accordion';
import AlertTheme from '../shared/alert';
import Animation from '../shared/animation';
import Avatar from '../shared/avatar';
import Button from '../shared/button';
import CheckboxTheme from '../shared/checkbox';
import ModalTheme from '../shared/modal';
import ProgressTheme from '../shared/progress';
import SliderTheme from '../shared/slider';
import TableTheme from '../shared/table';
import TabTheme from '../shared/tab';
import TagTheme from '../shared/tag';
import IconTheme from '../shared/icon';
import VerifyCodeTheme from '../shared/codeVerify';
import StripeInput from '../shared/stripeInput';
import { ThemesKeys } from '../shared/themeShared';
import Input from '../shared/input';
import InputSelect from '../shared/inputSelect';
import Textarea from '../shared/textarea';
import NumberInput from '../shared/inputNumber';
import DatePickerTheme from '../shared/datePicker';
import TimePickerTheme from '../shared/timePicker';
import RadioTheme from '../shared/radio';
import Dropdown from './dropdown';
import { themeBase } from './themeBase';

export const revooTheme = extendTheme({
  ...themeBase,
  styles: {
    global: {
      '@media (prefers-reduced-motion: reduce)': {
        '*, *::before, *::after': {
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
        },
      },
    },
  },
  components: {
    Accordion: AccordionTheme(ThemesKeys.themeRevoo),
    Alert: AlertTheme(ThemesKeys.themeRevoo),
    Animation,
    Avatar: Avatar(ThemesKeys.themeRevoo),
    Breadcrumb,
    Button,
    Checkbox: CheckboxTheme(ThemesKeys.themeRevoo),
    Datepicker: DatePickerTheme(ThemesKeys.themeRevoo),
    TimePicker: TimePickerTheme(ThemesKeys.themeRevoo),
    Input: Input(ThemesKeys.themeRevoo),
    InputSelect: InputSelect(ThemesKeys.themeRevoo),
    Menu: Dropdown(ThemesKeys.themeRevoo),
    Modal: ModalTheme(ThemesKeys.themeRevoo),
    NumberInput: NumberInput(ThemesKeys.themeRevoo),
    Progress: ProgressTheme(ThemesKeys.themeRevoo),
    Radio: RadioTheme(ThemesKeys.themeRevoo),
    Slider: SliderTheme(ThemesKeys.themeRevoo),
    Table: TableTheme(ThemesKeys.themeRevoo),
    Tabs: TabTheme(ThemesKeys.themeRevoo),
    Tag: TagTheme(ThemesKeys.themeRevoo),
    Textarea: Textarea(ThemesKeys.themeRevoo),
    Icon: IconTheme(),
    StripeInput: StripeInput(ThemesKeys.themeRevoo),
    CodeVerify: VerifyCodeTheme(ThemesKeys.themeRevoo),
  },
});
